import {ReactElement} from "react";

/*
 * The bundled 1000px wordmark, not the CDN's DevourPlayLogoWhite.webp: that
 * file is 154x28 and was being upscaled ~4x on retina, which read as pixelated.
 */
function AuthHeaderLogo(): ReactElement {
    return (
        <div className="auth-header-logo">
            <img
                src="/images/devourplay-logo.webp"
                alt="DevourPlay"
            />
        </div>
    );
}

export default AuthHeaderLogo;
